import { Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { LessonPlanLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import { LessonPlanVersionStatusMap } from "@/util/constants";
import { ILessonPlanVersionModel } from "@/models/lesson-plan";
import LabelText from "@/components/label-text/label-text.vue";
import { MethodologyType } from "@/util/enum";

@Component({
	components: {
		"a-select": Select,
		"a-select-option": Select.Option,
		LabelText
	}
})
export default class LessonPlanVersionSelect extends Vue {
	@Prop() lessonPlanVersions!: ILessonPlanVersionModel[];
	@Prop() value!: string;
	@Prop() isREP!: boolean;
	@Prop() containerStyle!: any;
	@Prop() labelStyle!: any;
	@Prop() selectStyle!: any;
	@Prop() displayMethodology!: boolean;

	get lessonPlanVersionText(): string {
		return fmtMsg(LessonPlanLocale.LessonPlanListLessonPlanVersionTitle);
	}

	getLessonPlanVersionDisplayText(lessonPlanVersion: ILessonPlanVersionModel): string {
		let result = `${lessonPlanVersion.name}`;
		if (this.displayMethodology && typeof lessonPlanVersion.methodology === "number") {
			const methodologyText =
				MethodologyType[(lessonPlanVersion.methodology as unknown) as keyof typeof MethodologyType];
			result = result + ` (${methodologyText})`;
		} else {
			result = result + `(${LessonPlanVersionStatusMap.get(lessonPlanVersion.status as number)})`;
		}
		return result;
	}

	onLessonPlanVersionChanged(value: string): void {
		this.$emit(
			"onLessonPlanVersionChanged",
			this.lessonPlanVersions.find((v) => v.id === value)
		);
	}
}
